import { Loader } from "@mantine/core";
import { createContext } from "react";
import { useDocument } from "react-firebase-hooks/firestore";
import { Company } from "../shared/company";
import LocationGateway from "./LocationGateway";

// @ts-expect-error We know we will have a company here so use this to avoid unwrapping all the time.
export const CompanyContext = createContext<Company>(null);

export default function CompanyGateway({children}: {children: React.ReactNode}) {
  const hostPts = window.location.hostname.split(".");
  let companyId;
  if (["localhost", "striped-93364"].includes(hostPts[0])) {
    companyId = "sgc_wandsworth";
  } else if (hostPts[0] === "members") {
    if (["sgcwandsworth", "wandsworth"].includes(hostPts[1])) {
      companyId = "sgc_wandsworth";
    } else {
      companyId = hostPts[1]; 
    }
  } else {
    throw new Error(`404 unknown host ${window.location.hostname}`);
  }

  const [companySS, loading, error] = useDocument(Company.ref(companyId));
  const company = companySS?.data();

  if (loading) return <Loader />;

  if (!company || error) {
    throw new Error(`404 unknown host ${companyId}`);
  }

  return <CompanyContext.Provider value={company} >
    <LocationGateway>
      {children}
    </LocationGateway>
  </CompanyContext.Provider>
}